<div class="modal notification-modal" tabindex="-1" role="dialog" *ngIf="activateModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="close()" data-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true">&times;</span></button>
                <h5 class="modal-title">Debug Log</h5>
            </div>
            <div class="modal-body">
                <div class="modal-message">
                    <textarea
                            style="overflow: scroll; height:600px; width:530px; font-size: 9pt; display: block; margin: 0 auto;">
                            {{ showLog() }}
                    </textarea>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade in" *ngIf="activateModal"></div>
